import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getAuthorListAsyncForTypeahead,
  getRubricListAsyncForTypeahead,
  getTemplateListAsyncForTypeahead,
  getSectionListAsyncForTypeahead,
  getFilteredSectionsForTypeahead,
  getFilteredPrimarySectionsForDropdown,
  getTagListAsyncForTypeahead,
  getFilteredTagsForTypeahead,
  getFilteredPrimaryTagsForDropdown,
  getSectionsForFeaturingDropdown,
} from "editor/actions/metadata";
import {
  updateFormAt,
  onChange,
  onChangeCheckbox,
  onChangeSlug,
  onBlurSlug,
} from "editor/actions/form";

import Checkbox from "components/library/Checkbox";
import DateTimeForm from "editor/components/DateTimeForm";
import InputGroup from "editor/components/InputGroup";

import styles from "./Publishing.css";
import { SECTIONS } from "config/constants";
import Embargo from "editor/components/Embargo/Embargo";

class Publishing extends React.Component {
  constructor(props) {
    super(props);
    this.idPrefix = Math.random()
      .toString(36)
      .substring(7);
  }

  getId(field) {
    return `${this.idPrefix}-${field}`;
  }

  render() {
    const isPinnedToTopCheck = featuredSections =>
      !!featuredSections.find(section => section.id === SECTIONS.TOP.id);
    return (
      <div className={styles.root}>
        <InputGroup
          headerText="Embargo"
          inputs={[
            <DateTimeForm
              key="embargo"
              disabled={this.props.status.isReadOnly}
              updateFormAt={this.props.updateFormAt}
              value={this.props.form.embargo_until}
              field="embargo_until"
              buttonText="embargo"
              formText="Set embargo for"
              setText={<Embargo form={this.props.form} showDate={false} />}
            />,
          ]}
        />
        <InputGroup
          headerText="Homepage Publishing"
          inputs={[
            <Checkbox
              key="add-to-top-stories"
              label="Add to top stories"
              isChecked={this.props.form.isTopStory}
              isDisabled={
                this.props.status.isReadOnly ||
                (!!this.props.form.primary_section &&
                  this.props.form.primary_section.id === SECTIONS.TOP.id)
              }
              onChange={this.props.onChangeCheckbox("isTopStory")}
            />,

            <Checkbox
              key="pin-to-top-stories"
              label="Pin to the top of “Top stories”"
              isChecked={isPinnedToTopCheck(this.props.form.featured_sections)}
              isDisabled={
                this.props.status.isReadOnly || !this.props.form.isTopStory
              }
              onChange={this.props.onChangeCheckbox(
                "featured_sections",
                isPinnedToTopCheck,
                [SECTIONS.TOP],
                []
              )}
            />,
            <DateTimeForm
              key="pin-to-top"
              disabled={
                this.props.status.isReadOnly ||
                !this.props.form.featured_sections.length
              }
              updateFormAt={this.props.updateFormAt}
              value={this.props.form.featured_date}
              featured_sections={this.props.form.featured_sections}
              field="featured_date"
              buttonText="pin expiration"
              formText="Automatically unfeature at"
              setText={<span>This story is set to unfeature on</span>}
            />,

            <Checkbox
              key="include-in-latest-stories"
              label="Include in “Latest stories”"
              isChecked={this.props.form.include_in_latest_stories}
              isDisabled={this.props.status.isReadOnly}
              onChange={this.props.onChangeCheckbox(
                "include_in_latest_stories"
              )}
            />,
          ]}
        />
        {/* TODO: Re-add when implemented on the backend  */}
        {/* <InputGroup */}
        {/*   headerText="Publishing Exclusions" */}
        {/*   inputs={[ */}
        {/*     <Checkbox */}
        {/*       key="remove-from-sections" */}
        {/*       label="Remove from sections" */}
        {/*       isChecked={false} */}
        {/*       isDisabled={true} */}
        {/*     />, */}
        {/*     <Checkbox */}
        {/*       key="exclude-from-story-recirc" */}
        {/*       label="Exclude from story recirc" */}
        {/*       isChecked={false} */}
        {/*       isDisabled={true} */}
        {/*     />, */}
        {/*   ]} */}
        {/* /> */}
        <InputGroup
          headerText="Off-site Publishing"
          inputs={[
            <Checkbox
              key="apple-news"
              label="Publish to Apple News"
              isChecked={this.props.form.publish_to_apple_news}
              isDisabled={this.props.status.isReadOnly}
              onChange={this.props.onChangeCheckbox("publish_to_apple_news")}
            />,
          ]}
        />
      </div>
    );
  }
}

Publishing.propTypes = {
  getBaseUrl: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  updateFormAt: PropTypes.func.isRequired,
  getAuthorListAsyncForTypeahead: PropTypes.func.isRequired,
  getTemplateListAsyncForTypeahead: PropTypes.func.isRequired,
  getRubricListAsyncForTypeahead: PropTypes.func.isRequired,
  getSectionListAsyncForTypeahead: PropTypes.func.isRequired,
  getFilteredSectionsForTypeahead: PropTypes.func.isRequired,
  getFilteredPrimarySectionsForDropdown: PropTypes.func.isRequired,
  getTagListAsyncForTypeahead: PropTypes.func.isRequired,
  getFilteredTagsForTypeahead: PropTypes.func.isRequired,
  getFilteredPrimaryTagsForDropdown: PropTypes.func.isRequired,
  getSectionsForFeaturingDropdown: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeCheckbox: PropTypes.func.isRequired,
  onChangeSlug: PropTypes.func.isRequired,
  onBlurSlug: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
  id: PropTypes.string,
};

const mapStateToProps = state => ({
  form: state.editor.form,
  status: state.editor.status,
});

const mapDispatchToProps = {
  getAuthorListAsyncForTypeahead,
  getRubricListAsyncForTypeahead,
  getTemplateListAsyncForTypeahead,
  getSectionListAsyncForTypeahead,
  getFilteredSectionsForTypeahead,
  getFilteredPrimarySectionsForDropdown,
  getTagListAsyncForTypeahead,
  getFilteredTagsForTypeahead,
  getFilteredPrimaryTagsForDropdown,
  getSectionsForFeaturingDropdown,
  updateFormAt,
  onChange,
  onChangeCheckbox,
  onChangeSlug,
  onBlurSlug,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Publishing);
